import { render } from "./side-panel-school.vue?vue&type=template&id=2fe08548&scoped=true"
import script from "./side-panel-school.vue?vue&type=script&lang=js"
export * from "./side-panel-school.vue?vue&type=script&lang=js"

import "./side-panel-school.vue?vue&type=style&index=0&id=2fe08548&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe08548"],['__file',"src/components/admin-dashboard/panels/side-panel-school.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fe08548"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fe08548', __exports__)) {
    api.reload('2fe08548', __exports__)
  }
  
  module.hot.accept("./side-panel-school.vue?vue&type=template&id=2fe08548&scoped=true", () => {
    api.rerender('2fe08548', render)
  })

}


export default __exports__